import React, { FunctionComponent } from 'react';
import Box from '@material-ui/core/Box';
import SummaryLabelTitle from '../../../summaryLabel/SummaryLabelTitle';
import PriceValue from '../priceValue/PriceValue';
import Translation from '../../../../../../../../gqlCommon/components/translation/Translation';
import { TaxTypes } from '../../../../../../../../../../common/enum/TaxTypes';
import { PriceDisplayType } from '../../../../../../../../../../common/enum/PriceDisplayType';
import { GetCustomizeCar_customizeCar_prices_totalPrice_taxes } from '../../../../../../../graphql/queries/__generated__/GetCustomizeCar';
import { taxTypeTranslationMap } from '../../../../../../../constants/taxTypeTranslationMap';

export interface ISummaryTaxesRow {
  loading?: boolean;
  currency: string;
  tax: GetCustomizeCar_customizeCar_prices_totalPrice_taxes;
}

const SummaryTaxesRow: FunctionComponent<ISummaryTaxesRow> = ({ loading, currency, tax }) => {
  if (!tax) {
    return null;
  }

  const { label, type, money } = tax;
  const hasTranslation = type in TaxTypes && !!taxTypeTranslationMap[type as TaxTypes];

  return (
    <>
      <SummaryLabelTitle
        label={
          <Box data-test={`customise:summary:tax_${type.toLowerCase()}_label`} component="span">
            {label ? label : hasTranslation ? <Translation id={taxTypeTranslationMap[type as TaxTypes]} /> : type}
          </Box>
        }
        boldLabel={false}
        colSm={8}
        colXs={6}
      />
      <PriceValue
        loading={loading}
        price={money.amount}
        priceType={PriceDisplayType.PRIMARY}
        currency={currency}
        boldPrice={true}
        testId={`tax_${type.toLowerCase()}`}
      />
    </>
  );
};

export default SummaryTaxesRow;
